import { ToolbarElement } from './ToolbarElement'

const entryTemplate = `
<div class="toolbar-split-dropdown-icon"></div>
<div class="toolbar-split-dropdown-arrow"></div>
`

interface IToolbarSplitDropdownElementConfig {
  overlayElementWidth?: number
  entryElementHeight?: number
  topOffset?: number
}

export abstract class ToolbarSplitDropdownElement extends ToolbarElement {
  public entryElement = document.createElement('div')
  public overlayElement = document.createElement('div')
  constructor(
    overlayContainer: HTMLDivElement,
    public readonly name: string,
    public readonly config?: IToolbarSplitDropdownElementConfig,
  ) {
    super(overlayContainer)
    this.initDom()
    this.initEvent()
  }

  public getEntryElement(): HTMLElement {
    return this.entryElement
  }

  protected initDom() {
    this.entryElement.classList.add(`toolbar-split-dropdown-${this.name}`, 'toolbar-split-dropdown')
    this.entryElement.innerHTML = entryTemplate

    this.overlayElement.classList.add(`toolbar-split-dropdown-menu-${this.name}`, 'toolbar-split-dropdown-menu')
    this.overlayElement.style.width = `${this.config?.overlayElementWidth ?? 0}px`
  }

  protected initEvent() {
    this.entryElement.addEventListener('mousedown', (event) => {
      event.preventDefault()
    })
    this.overlayElement.addEventListener('mousedown', (event) => {
      event.preventDefault()
    })
    this.entryElement.querySelector('.toolbar-split-dropdown-icon')?.addEventListener('click', () => {
      this.emitClick()
    })
    this.entryElement.querySelector('.toolbar-split-dropdown-arrow')?.addEventListener('click', () => {
      this.showOverlay()
    })
    this.overlayElement.addEventListener('click', () => {
      this.hideOverlay()
    })
  }

  protected emitClick() {
    this.emit(`click-${this.name}`)
  }

  protected showOverlay() {
    const overlayElementWidth = this.config?.overlayElementWidth ?? 0
    const entryElementHeight = this.config?.entryElementHeight ?? 0
    const topOffset = this.config?.topOffset ?? 0
    const entryBounding = this.entryElement.getBoundingClientRect()
    const overlayContainerBounding = this.overlayContainer.getBoundingClientRect()

    this.overlayElement.style.left = `${Math.max(
      Math.min(
        entryBounding.left - overlayContainerBounding.left - overlayElementWidth / 2 + entryBounding.width / 2,
        overlayContainerBounding.width - overlayElementWidth - 5,
      ),
      5,
    )}px`
    this.overlayElement.style.top = `${
      entryBounding.top - overlayContainerBounding.top + entryElementHeight + topOffset
    }px`
    this.overlayElement.style.display = 'block'
    document.addEventListener('mousedown', this.onDocumentMousedown, true)
  }

  protected hideOverlay() {
    this.overlayElement.style.display = 'none'
    document.removeEventListener('mousedown', this.onDocumentMousedown, true)
  }

  protected onDocumentMousedown = (event: MouseEvent) => {
    this.overlayElement.contains(event.target as Node) ||
      this.entryElement.contains(event.target as Node) ||
      this.hideOverlay()
  }
}
